import api from './api';

// Staff-side, read-only in practice: only the applicant may grant or withdraw their own consent
// (ConsentPolicy) — applicantService.js already covers that flow. This exists for staff viewing a
// consent history on an application (ApplicationDetail).
const consentService = {
  getConsents: async (applicationId) => (await api.get(`/applications/${applicationId}/consent`)).data
};

export default consentService;
